const constants = {
  LOGIN_CHANGE_USER: 'LOGIN_CHANGE_USER',
  LOGIN_CHANGE_PASSWORD: 'LOGIN_CHANGE_PASSWORD',
  LOGIN_LOADING: 'LOGIN_LOADING',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_USER_FETCH: 'LOGIN_USER_FETCH',
  LOGIN_FAILED: 'LOGIN_FAILED',
  LOGIN_INITIAL: 'LOGIN_INITIAL',
  LOGIN_GO_RESTORE: 'LOGIN_GO_RESTORE',
  LOGIN_GO_LOGIN: 'LOGIN_GO_LOGIN',
  RESTORE_SENT: 'RESTORE_SENT',
  RESTORE_GET_APPROVE: 'RESTORE_GET_APPROVE'
};

export default constants;
